export const indexCopy = {
  index_headline: "<bold>Typed JavaScript at Any Scale.</bold>",
  index_byline: "TypeScript extends JavaScript by adding types.",
  index_summary:
    "By understanding JavaScript, TypeScript saves you time catching errors and providing fixes before you run code.",
  index_locations:
    "Any browser, any OS, anywhere JavaScript runs. Entirely Open Source.",

  index_cta_play: "Try in your browser",
  index_cta_install: "Install locally",

  index_what_is: "What is TypeScript?",

  index_what_is_js: "JavaScript and More",
  index_what_is_js_copy: `
<p>TypeScript is an open-source language which builds on JavaScript, one of the world’s most used tools, by adding static type definitions.</p>

<p>Types provide a way to describe the shape of an object, providing better documentation, and allowing TypeScript to validate that your code is working correctly.</p>

<p>Writing types can be optional in TypeScript, because type inference allows you to get a lot of power without writing additional code.</p>`,

  index_trust: "A Result You Can Trust",
  index_trust_copy_a: `All valid JavaScript code is also TypeScript code. You might get type-checking errors, but that won't stop you from running the resulting JavaScript. While you can go for stricter behavior, that means you're still in control.`,
  index_trust_copy_b: `TypeScript code is transformed into JavaScript code via the TypeScript compiler or <babel>Babel</babel>. This JavaScript is clean, simple code which runs anywhere JavaScript runs: In a browser, on Node.JS or in your apps.`,
  index_standards: "Evolving with Standards",
  index_standards_copy: `
  <p>The TypeScript team contributes to the TC39 committees which help guide the evolution of the JavaScript language.</p>

  <p>When new features have reached stage 3, then they are ready for inclusion in TypeScript.</p>
  
  <p>For example the TypeScript team championed proposals like Optional Chaining, Nullish coalescing Operator, Throw Expressions and RegExp Match Indices.</p>`,

  index_gradual: "Gradual Adoption",
  index_gradual_copy: `
<p>Adopting TypeScript is not a binary choice, you can start by annotating existing JavaScript with JSDoc, then switch a few files to be checked by TypeScript and over time prepare your codebase to convert completely.</p>

<p>TypeScript’s type inference means that you don’t have to annotate your code until you want more safety.</p>`,

  index_dts: "Types On Every Desk",
  index_dts_copy: `
<p>Most of the worlds JavaScript’s is un-typed, and inference can only go so far. To address this, the TypeScript team helps maintain <dt>Definitely Typed</dt> - a community project to provide types and inline documentation to existing JavaScript.

<p>This project allows the community to maintain type definitions for JavaScript libraries without putting extra pressure on their maintainers.</p>`,

  index_tools: "Consistently Good Tooling",
  index_tools_copy: `
  <p>By handling a lot of the editor integration inside TypeScript, you can get a consistent experience working in many editors.</p>

  <p>This lets you easily jump between editors like <vs>Visual Studio</vs>, <vsc>Visual Studio Code</vsc>, <nova>Nova</nova>, <atom>Atom</atom>, <subl>Sublime Text</subl>, <emacs>Emacs</emacs>, <vim>Vim</vim>, <webs>WebStorm</webs> and <eclipse>Eclipse</eclipse>.</p>

  <p>TypeScript's editor integration supports JavaScript, so it's quite likely you're already using TypeScript under the hood.
  `,

  index_started_title: "Get Started",
  index_started_handbook: "Handbook",
  index_started_handbook_blurb: "Learn the language",
  index_started_docs: "Start a Project",
  index_started_docs_blurb: "Find a bootstrapping tool",
  index_started_tooling: "Tooling",
  index_started_tooling_blurb: "Deep dives into TypeScript",
  index_started_community: "Community",
  index_started_community_blurb: "Keep up to date",
  index_install: "Install TypeScript",
  index_install_ref: `
  <p>You can install TypeScript via npm<pre>npm install -g typescript</pre>
  <p>Then run the compiler via <code>tsc</code><pre>npx tsc</pre>
  <p>Learn more about how to add TypeScript to your apps in the <download>installation page</download>
  `,
  index_releases: "Quarterly Releases",
  index_releases_pt1: "Our next release is ",
  index_releases_pt2: ", which is planned for ",
  index_releases_released: "Released",
  index_releases_beta: "Beta",
  index_releases_rc: "RC",

  index_migration_title: "Migration Stories",
  index_migration_oss: "Open Source with TypeScript",
  index_videos_title: "Watch TypeScript in Action",
}
